// extracted by mini-css-extract-plugin
export var pillWrapper = "_pv-0";
export var showOverflow = "_pv-1";